/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthStrictHttpResponse } from '../../auth-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserRegistrationModel } from '../../models/user-registration-model';

export interface LocalAccountRegisterUserPost$Params {
      body?: UserRegistrationModel
}

export function localAccountRegisterUserPost(http: HttpClient, rootUrl: string, params?: LocalAccountRegisterUserPost$Params, context?: HttpContext): Observable<AuthStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, localAccountRegisterUserPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as AuthStrictHttpResponse<void>;
    })
  );
}

localAccountRegisterUserPost.PATH = '/LocalAccount/RegisterUser';
